import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Course } from '../../../models/course'
import { Resources } from '../../../models/resources'
import { Teacher } from '../../../models/teacher'
import { TeacherProvider } from '../../../providers/teacher/teacher.provider'
import { PreferencesProvider } from '../../../providers/preferences/preferences.provider'
import { ResourcesProvider } from '../../../providers/resources/resources.provider'
import { Collection } from '../../../models/collection'
import { MenuPopoverComponent } from '../../../components/menu-popover/menu-popover.component'
import { Common } from '../../../lib/common'
import { PopoverController } from '@ionic/angular'
import { CourseCssService } from '../course-css.service'
import { MessagePopoverComponent, MessagePopoverButton } from 'src/app/components/message-popover/message-popover.component';
import { AccessCodePopoverComponent } from 'src/app/components/access-code-popover/access-code-popover.component';
import { DatePopoverComponent } from 'src/app/components/date-popover/date-popover.component';

@Component({
  selector: 'app-course-header-edit',
  templateUrl: './course-header-edit.component.html',
  styleUrls: ['./course-header-edit.component.scss']
})
export class CourseHeaderEditComponent implements OnInit {
  @Input() course: Course

  _resources: Resources = Resources.defaults()
  get resources(): Resources { return this._resources }
  @Input() set resources(resources: Resources) { this._resources = resources ||  Resources.defaults() }

  _teacher: Teacher = Teacher.defaults()
  get teacher(): Teacher { return this._teacher }
  @Input() set teacher(teacher: Teacher) { this._teacher = teacher ||  Teacher.defaults() }

  @Output() save = new EventEmitter<Course>()
  @Output() cancel = new EventEmitter<Course>()

  constructor(
    private teacherProvider: TeacherProvider,
    private resourcesProvider: ResourcesProvider,
    private preferencesProvider: PreferencesProvider,
    private popoverCtrl: PopoverController,
    public courseCssService: CourseCssService
  ) { }

  ngOnInit() {
  }

  isSaveEnabled(): boolean {
    return this.course.collectionUuid &&
      this.course.startDate.month &&
      this.course.startDate.day &&
      this.course.startDate.year &&
      this.course.classType !== Course.ClassType.None
  }

  saveEdit() {
    this.save.emit(this.course)
  }

  cancelEdit() {
    this.cancel.emit(this.course)
  }


  get collections(): Collection[] {
    return this.teacher.collectionsFrom(this.resources?.collections || [])
  }

  chooseCollection(event) {
    const collections = this.collections.filter((collection: Collection) => !collection.name.startsWith('Welcome'))
    if (collections.length > 0) {
      MenuPopoverComponent.present(this.popoverCtrl, 'lesson-plans-popover', event,
        Collection.sort(collections).map((collection: Collection) => {
          return {name: collection.name, action: () => { this.course.collectionUuid = collection.uuid }}
        })
      )
    } else {
      MessagePopoverComponent.present(this.popoverCtrl, 'No collections unlocked', 'To unlock collections, you will need to enter a teacher access code.', false, false, [
        { name: 'Cancel', type: MessagePopoverButton.Type.Cancel },
        { name: 'Access Code', type: MessagePopoverButton.Type.Submit, action: () => {
          setTimeout(() => {
            this.popoverCtrl.create({
                component: AccessCodePopoverComponent,
                cssClass: 'access-code-popover'
            }).then(popover => {
                popover.present().then(() => Common.ensurePopoverOnScreen())
            })
          }, 500)
        } }
      ])
    }
  }

  async chooseDate(event){
    this.popoverCtrl.create({
      component: DatePopoverComponent,
      cssClass: 'lesson-plans-popover',
      componentProps: { defaultDate: this.course?.startDateAsDate() }
    }).then(popover => {
      popover.present(event).then(() => Common.ensurePopoverOnScreen())
      popover.onDidDismiss().then(results => {
      if (results && results.data) {
        const date = results?.data
        this.course.startDate.day = new Date(results?.data).getDate().toString();
        this.course.startDate.month = '' + Common.months[new Date(date).getMonth()];
        this.course.startDate.year = '' + new Date(date).getFullYear().toString();
      }
    })
  })

  }


  // chooseMonth(event) {
  //   MenuPopoverComponent.present(this.popoverCtrl, 'lesson-plans-popover', event,
  //     Common.months.map((month: string) => {
  //       return {name: month, action: () => { this.course.startDate.month = month }}
  //     }), 110
  //   )
  // }

  // chooseDay(event) {
  //   const days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
  //   MenuPopoverComponent.present(this.popoverCtrl, 'lesson-plans-popover', event,
  //     days.map((day: number) => {
  //       return {name: '' + day, action: () => { this.course.startDate.day = '' + day }}
  //     }), 80
  //   )
  // }

  // chooseYear(event) {
  //   const years = [2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030]
  //   MenuPopoverComponent.present(this.popoverCtrl, 'lesson-plans-popover', event,
  //     years.map((year: number) => {
  //       return {name: '' + year, action: () => { this.course.startDate.year = '' + year }}
  //     }), 110
  //   )
  // }

  chooseClassType(event) {
    const classTypes = [Course.ClassType.MixedAges, Course.ClassType.Babies, Course.ClassType.Generations, Course.ClassType.RhythmKids, Course.ClassType.InSchool]
    MenuPopoverComponent.present(this.popoverCtrl, 'lesson-plans-popover', event,
      classTypes.map((type: Course.ClassType) => {
        return {name: type, action: () => { this.course.classType = type }}
      })
    )
  }

  getSelectedDate() {

    if (this.course?.startDate == null) {
      console.log('here')
      return
    }



    // if(!this.course && !this.course.startDate) {
    //   return
    // }
    // if (this.course.startDate == '') {

    // }

    // console.log(this.course)
    // console.log(this.course.startDate)

    return `${this.course.startDate.day}/${this.course.startDate.month}/${this.course.startDate.year}` || '';
  }
}
